import Backdrop from "@material-ui/core/Backdrop";
import { useTranslation } from "i18n/useTranslation";
import React, { FC, useEffect, useState } from "react";
import load from "../../../../assets/lottie/load.gif";
import "./PendingPaymentModal.css";

interface IPendingPaymentModalProps {
  open: boolean;
  /** Prazo da consulta 130 (registro PENDING sem retorno do m-SiTef) */
  deadline?: number;
}

const formatRemaining = (ms: number) => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

/** Bloqueia o totem enquanto um pagamento que ficou pendente no app é confirmado */
const PendingPaymentModal: FC<IPendingPaymentModalProps> = ({ open, deadline }) => {
  const { t } = useTranslation();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!open || !deadline) {
      return;
    }
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [open, deadline]);

  return (
    <Backdrop className="PendingPaymentModal" open={open}>
      <div className="PendingPaymentModal-content">
        <img src={load} alt="" width={150} height={150} />
        <h2>{t("payment_recovery.title")}</h2>
        <p>{t("payment_recovery.description")}</p>
        {!!deadline && deadline > now && (
          <p className="PendingPaymentModal-remaining">
            {t("payment_recovery.remaining", { time: formatRemaining(deadline - now) })}
          </p>
        )}
      </div>
    </Backdrop>
  );
};

export default PendingPaymentModal;
